import {Component, Input} from '@angular/core';
import {FormGroup} from "@angular/forms";

@Component({
    selector: 'app-calendar-input',
    templateUrl: './calendar-input.component.html',
    standalone: false
})
export class CalendarInputComponent {
  @Input() formGroup: FormGroup
  @Input() id: string
  @Input() label: string
  @Input() maxDate: Date
  @Input() minDate: Date
  @Input() formError: string
  @Input() touchUI = false
}
